<template>
  <form @submit.prevent>
    <input v-show='active'
           v-if='kirby.site.strings'
           v-model='query'
           ref='search'
           :class='{phone: size == "phone"}'
           autofocus
           @input='updateQuery'
           :placeholder='kirby.site.strings.searchplaceholder' />
    <button aria-label="Left Align" @click='$emit("toggleSearch"); !active ? $emit("addReasonToShowVeil") : $emit("removeReasonToShowVeil")'>
      <magnifyingGlass :active='active' />
    </button>
  </form>
</template>

<script>
import mixins from '.././mixins.js';
import axios from 'axios';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  props: ['active', 'results'],
  data: function() {
    return {
      query: '',
    }
  },
  watch: {
    active() {
      setTimeout(() => { this.$refs.search.focus(); }, 10);
    }
  },
  methods: {
    updateQuery() {
      const http = axios.create({method: 'GET', credentials: 'include', mode: 'no-cors', headers: { Accept: '*/*' } });
      var self = this;
      if(this.query.length > 1) {
        http.get('search?query=' + this.query +'&fields=title|text|transcript|author').then(response => {
          console.log(this.query, response.data);
          self.$emit('update:results', response.data);
        });
      } else {
        self.$emit('update:results', '');
      }
    }
  }
}
</script>

<style scoped>
  button {
    background-color: transparent;
    padding: 0;
  }

  form {
    display: flex;
    flex-direction: row;
  }

  input {
    box-sizing: border-box;
    height: 2.65rem;
    font-weight: normal;
    font-size: 2em;
    color: var(--blue);
    font-family: 'clarendon', serif;
    outline: none;
    border: none;
    background-color: transparent;
    flex-grow: 3;
    border-bottom: var(--thinline);
    vertical-align: top;
    padding: 0 0em 1.25rem 0em;
  }

  input.phone {
    font-size: 1.5em;
    width: 12em;
    overflow: hidden;
    display: block;
    padding-bottom: 0.5em;
  }


  input::placeholder {
    color: var(--mint);
  }

  button {
    flex-grow: 0;
  }

  * {
    outline-style: none
  }
</style>
